import { useRouteError, Link } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { useTranslation } from "../hooks/useTranslation";
import "../assets/styles/errorPage.css";

export default function ErrorPage() {
    const t = useTranslation();
    const error = useRouteError();

    return (
        <section className="error-page">
            <div className="glass-wrapper error-card">
                <img src={logo} alt="Logo" className="error-logo" />

                <h1 className="error-title">
                    {t("error.title")}{" "}
                    <span role="img" aria-label="Sad face">
                        😢
                    </span>
                </h1>

                <p className="error-message">
                    {t("error.message")}
                    <br />
                    {error.statusText || error.message}
                </p>

                <Link to="/" className="error-btn">
                    {t("error.backhome")}
                </Link>
            </div>
        </section>
    );
}
